import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SendMailModal } from "@/components/AgevolazioneModal";

// Dialog autonomo per inviare la scheda Agevolazione via mail direttamente dalla lista,
// senza aprire la scheda completa. Riusa SendMailModal (con anteprima leggibile).
// Il backend costruisce il PDF dai dati salvati della scheda (pag_iscrizione/pag_rette dal DB).
export default function AgevMailModal({ cod, anno, onClose }) {
  const [dlg, setDlg] = useState({ loading: true });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get(`/agevolazioni/${cod}/${anno}/mail-preset`);
        const p = r.data || {};
        if (cancelled) return;
        setDlg({
          loading: false,
          to: (p.to || []).join(", "),
          subject: p.subject_default || "",
          body: p.body_default || "",
          alunno: p.alunno || null,
          sending: false,
        });
      } catch (e) {
        if (cancelled) return;
        setDlg({ loading: false, to: "", subject: "", body: "", sending: false, err: e.response?.data?.detail || e.message });
      }
    })();
    return () => { cancelled = true; };
  }, [cod, anno]);

  const onSend = async () => {
    const to = (dlg.to || "").split(/[,;\s]+/).map((s) => s.trim()).filter(Boolean);
    if (!to.length) { setDlg((m) => ({ ...m, err: "Inserire almeno un destinatario." })); return; }
    if (!(dlg.subject || "").trim()) { setDlg((m) => ({ ...m, err: "Oggetto obbligatorio." })); return; }
    if (!(dlg.body || "").trim()) { setDlg((m) => ({ ...m, err: "Corpo email obbligatorio." })); return; }
    setDlg((m) => ({ ...m, sending: true, err: null }));
    try {
      const res = await api.post(`/agevolazioni/${cod}/${anno}/send-mail`, {
        to, subject: dlg.subject, body: dlg.body,
      });
      const d = res.data || {};
      if (d.ok) {
        setDlg((m) => ({
          ...m, sending: false,
          ok: `Email inviata a ${d.sent?.length || to.length} destinatari — allegato: ${d.attachment || "PDF"}` +
            (d.errors?.length ? ` (${d.errors.length} errori: ${d.errors.map((e) => e.email).join(", ")})` : ""),
          err: null,
        }));
      } else {
        setDlg((m) => ({ ...m, sending: false, err: "Invio fallito: " + (d.errors?.map((e) => `${e.email}: ${e.error}`).join("; ") || "vedi log") }));
      }
    } catch (e) {
      setDlg((m) => ({ ...m, sending: false, err: "Errore invio: " + (e.response?.data?.detail || e.message) }));
    }
  };

  return <SendMailModal dlg={dlg} onChange={(patch) => setDlg((m) => ({ ...m, ...patch }))} onClose={onClose} onSend={onSend} />;
}
